import Breadcrumb from "../breadcrumb/Breadcrumb";
import SmallBanner from "../common/SmallBanner";

const Banner = () => {
    return (
        <SmallBanner titile="Kurs" cls="blog">
            <Breadcrumb
                breadcrumbs={[
                    ["Home", "/"],
                    ["Kurs", "/"],
                ]}
            />
        </SmallBanner>
    );
};

export default Banner;
